/**
 * Constants for Unify Onboarding Step 2 POS Connection
 */

/**
 * Connection kind types
 */
export const CONNECTION_KIND = {
  STOCK: 'stock',
  PRODUCT: 'product',
};

/**
 * Connection type methods
 */
export const CONNECTION_TYPE = {
  OAUTH: 'oauth',
  PLUG_PLAY: 'plug-play',
  PARTNER_LEAD: 'partner-lead',
};

/**
 * Form field types from provider configuration
 */
export const FIELD_TYPE = {
  TEXT: 'text',
  PASSWORD: 'password',
  CHECKBOX: 'checkbox',
  FTP_DETAILS: 'ftp-details',
};

/**
 * FTP details display variants
 */
export const FTP_VARIANT = {
  FTP: 'ftp',
  EMAIL: 'email',
  UPLOAD_KEY: 'uploadKey',
};

/**
 * Polling configuration
 */
export const POLLING_CONFIG = {
  INTERVAL_MS: 3000,        // Poll every 3 seconds
  TIMEOUT_MS: 180000,       // Timeout after 3 minutes
  MAX_ATTEMPTS: 60,         // 180000 / 3000
};

/**
 * Session storage keys for OAuth session IDs
 */
export const SESSION_STORAGE_KEYS = {
  STOCK_SESSION: 'unify_oauth_stock_session_id',
  PRODUCT_SESSION: 'unify_oauth_product_session_id',
};

/**
 * Warning messages
 */
export const CONNECTION_WARNINGS = {
  STOCK_TIMEOUT: 'No stock upload received yet. This can take a few minutes depending on your inventory size.',
  PRODUCT_TIMEOUT: 'No product data upload received yet. This can take a few minutes.',
};

/**
 * Submit types for plug-and-play connections
 */
export const SUBMIT_TYPE = {
  SPINNER: 'spinner',
  BUTTON: 'button',
};
